import React from 'react';
import PersonaCard from '../components/PersonaCard';
import { BuildingIcon, GraduationCapIcon, ShieldIcon, BriefcaseIcon, LandmarkIcon, BookOpenIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Home: React.FC = () => {
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-2512">
      <div className="max-w-5xl w-full" data-id="element-2513">
        <div className="text-center mb-12" data-id="element-2514">
          <h1 className="text-3xl font-bold text-gray-800 mb-3" data-id="element-2515">
            Welcome to the Future of Work Navigator
          </h1>
          <p className="text-gray-600 text-lg mb-6" data-id="element-2516">
            This platform connects students, universities, employers, and
            government agencies in a unified ecosystem for higher education and
            workforce development. Explore the platform through one of the user
            personas below.
          </p>
          <Link to="/overview" className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700" data-id="element-2517">
            <BookOpenIcon className="w-4 h-4 mr-2" data-id="element-2518" />
            Learn more about the platform
          </Link>
        </div>
        {/* First row - Student and University */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-2519">
          <PersonaCard title="Student" description="Browse programs & scholarships. Apply and track status." icon={<GraduationCapIcon className="w-10 h-10" data-id="element-2521" />} path="/student" data-id="element-2520" />
          <PersonaCard title="University Coordinator" description="Manage UAE programs & student applications" icon={<BuildingIcon className="w-10 h-10" data-id="element-2523" />} path="/university" data-id="element-2522" />
        </div>
        {/* Second row - MoHESR, Company, and Admin */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2524">
          <PersonaCard title="MoHESR Admin" description="Manage Elite Track & approve scholarships" icon={<LandmarkIcon className="w-10 h-10" data-id="element-2526" />} path="/mohesr" data-id="element-2525" />
          <PersonaCard title="Company/Partner" description="Create scholarships & screen applicants" icon={<BriefcaseIcon className="w-10 h-10" data-id="element-2528" />} path="/employer" data-id="element-2527" />
          <PersonaCard title="Platform Admin" description="Monitor ecosystem metrics & system insights" icon={<ShieldIcon className="w-10 h-10" data-id="element-2530" />} path="/admin" data-id="element-2529" />
        </div>
      </div>
      <footer className="mt-16 text-center text-sm text-gray-500" data-id="element-2531">
        © {new Date().getFullYear()} UAE Government-University Portal
      </footer>
    </div>;
};
export default Home;